import React from 'react';
import { withRouter } from 'react-router-dom';
import OrderHeaderComponent from './components/view/OrderHeaderComponent';
import OrderInformationComponent from './components/view/OrderInformationComponent';
import MachineInformationComponent from './components/view/MachineInformationComponent';
import OrderInstallationComponent from './components/view/OrderInstallationComponent';
import OrderActivitiesComponent from './components/view/OrderActivitiesComponent';
import OrderShipmentsAndLineItemsComponent from './components/view/OrderShipmentsAndLineItemsComponent';
import OrderDocumentsContainer from './components/view/documents/OrderDocumentsContainer';
import { ordersService } from '../orders/ordersService';
import { Spinner } from '@ami/react/core';
//import './OrderViewPage.scss';
import CustomActivityModal from './components/view/CustomActivityModal';
import { ProductConfiguration } from '../products/productConfiguration';
import { appConfig } from '@ami/react/core';
import OrderLineItemsComponent from './components/view/OrderLineItemsComponent';
import OrderCustomLineItemsComponent from './components/view/OrderCustomLineItemsComponent';
import AmiTaskPanel from '../ami-tasks/AmiTaskPanel';
import CustomerApprovalPanel from '../customer-approvals/CustomerApprovalPanel';
import OrderCancelModal from './OrderCancelModal';
import RequestNewShipDateModal from './components/view/RequestNewShipDateModal';

class OrderViewPageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.customActivityModalRef = React.createRef();
    this.requestNewShipDateModalRef = React.createRef();
  }
  state = {
    order: null,
    showCancelConfirmationModal: false,
    productConfiguration: null,
  };

  async componentDidMount() {
    this.setState({
      productConfiguration: await ProductConfiguration.get(),
    });
    this.loadOrder();
  }

  loadOrder = async () => {
    this.setState({
      order: await ordersService.getViewById(this.props.match.params.id),
    });
  };

  cancel = async () => {
    this.loadOrder();
  };

  render() {
    const { order, productConfiguration, showCancelConfirmationModal } =
      this.state;
    if (!order || !productConfiguration) {
      return (
        <div className="container text-center">
          <h4 className="mt-5 mb-2">Loading</h4>
          <Spinner show={true} size="fa-5x" />
        </div>
      );
    }

    return (
      <div className="container">
        <OrderHeaderComponent
          order={order}
          onCancel={() => this.setState({ showCancelConfirmationModal: true })}
          onAddCustomActivity={() => this.customActivityModalRef.current.show()}       
          onRequestShipDateTime={() =>
            this.requestNewShipDateModalRef.current.show()
          }
        />
        <div className="row row-cols-1 row-cols-md-2 mb-3">
          <OrderInformationComponent order={order} />
          <MachineInformationComponent order={order} />
        </div>
        <div className="row">
          {appConfig.isManagementApp && (
            <OrderShipmentsAndLineItemsComponent
              order={order}
              onShipmentsUpdated={this.loadOrder}
              productConfiguration={productConfiguration}
            />
          )}
          {!appConfig.isManagementApp && (
            <div className="col">
              <div className="card mb-3 box-shadow">
                <div className="card-body order-shipments">
                  <div className="order-shipments">
                    <h6 className="card-title text-center">Products</h6>
                    <OrderLineItemsComponent
                      order={order}
                      productConfiguration={productConfiguration}
                      loadOrder={this.loadOrder}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {order.customLineItems.length > 0 && (
          <OrderCustomLineItemsComponent order={order} />
        )}
        {order.installation && (
          <div className="row row-cols-1 mb-3">
            <OrderInstallationComponent order={order} />
          </div>
        )}
        <div className="row row-cols-1 row-cols-md-2 mb-3">
          <CustomerApprovalPanel entity={order} />
          <OrderDocumentsContainer
            order={order}
            onDocumentsUpdated={this.loadOrder}
          />
        </div>
        {appConfig.isManagementApp && (
          <div className="row row-cols-1">
            <AmiTaskPanel
              idrelated={order.id}
              isOrder={true}
              enabledAddNew={true}
            />
          </div>
        )}
        <div className="row row-cols-1">
          <OrderActivitiesComponent order={order} />
        </div>
        <OrderCancelModal
          entityId={order.id}
          onChanged={this.cancel}
          show={showCancelConfirmationModal}
          onHide={() => this.setState({ showCancelConfirmationModal: false })}
        />
        <CustomActivityModal
          ref={this.customActivityModalRef}
          orderId={this.state.order.id}
          onChanged={this.loadOrder}
        />
        <RequestNewShipDateModal
          ref={this.requestNewShipDateModalRef}
          orderId={this.state.order.id}
          onChanged={this.loadOrder}
        />
    
      </div>
    );
  }
}

const OrderViewPage = withRouter(OrderViewPageComponent);
export { OrderViewPage };
